/* Cura della Scarpa — theme.js */
(function(){
  'use strict';

  /* scritte dell'interfaccia: arrivano tradotte dal layout, mai fisse qui */
  function S(key, fallback){ var m = window.themeStrings || {}; return m[key] || fallback; }
  /* radice della lingua corrente, esposta da Shopify: '' in italiano, '/en' sull'inglese */
  function R(){ return String((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/').replace(/\/+$/, ''); }

  /* ---------- Focus management drawer ---------- */
  var FOCUSABLE = 'a[href],button:not([disabled]),input,select,textarea,[tabindex]:not([tabindex="-1"])';
  var lastFocus = null;
  function moveFocusTo(sel){
    var root = document.querySelector(sel); if(!root) return;
    lastFocus = document.activeElement;
    var f = root.querySelector(FOCUSABLE); if(f) f.focus();
  }
  function restoreFocus(){
    if(lastFocus && document.contains(lastFocus)){ lastFocus.focus(); }
    lastFocus = null;
  }
  document.addEventListener('keydown', function(e){
    if(e.key !== 'Tab') return;
    var sel = body.classList.contains('cart-open') ? '.cart-drawer' : body.classList.contains('nav-open') ? '.mobile-nav' : null;
    if(!sel) return;
    var root = document.querySelector(sel); if(!root) return;
    var items = Array.prototype.filter.call(root.querySelectorAll(FOCUSABLE), function(el){ return el.offsetParent !== null; });
    if(!items.length) return;
    var first = items[0], last = items[items.length-1];
    var inside = root.contains(document.activeElement);
    if(e.shiftKey && (document.activeElement === first || !inside)){ e.preventDefault(); last.focus(); }
    else if(!e.shiftKey && (document.activeElement === last || !inside)){ e.preventDefault(); first.focus(); }
  });

  /* ---------- Cart drawer open/close ---------- */
  var body = document.body;
  function openCart(){ body.classList.add('cart-open'); moveFocusTo('.cart-drawer'); }
  function closeCart(){ if(body.classList.contains('cart-open')){ body.classList.remove('cart-open'); restoreFocus(); } }

  document.addEventListener('click', function(e){
    var openBtn = e.target.closest('[data-cart-open]');
    if(openBtn){
      if(window.__cartType === 'page'){ return; } // let link navigate
      e.preventDefault(); openCart(); return;
    }
    if(e.target.closest('[data-cart-close]')){ e.preventDefault(); closeCart(); }
  });
  document.addEventListener('keydown', function(e){ if(e.key==='Escape') closeCart(); });

  /* ---------- Cart AJAX helpers ---------- */
  function fmtMoney(cents){
    try { return (cents/100).toLocaleString('it-IT',{style:'currency',currency:window.__shopCurrency||'EUR'}); }
    catch(_){ return '€'+(cents/100).toFixed(2); }
  }
  window.CDS_fmtMoney = fmtMoney;

  function refreshCart(){
    return fetch(R() + '/cart.js',{headers:{'Accept':'application/json'}})
      .then(function(r){return r.json();})
      .then(function(cart){ renderDrawer(cart); updateCount(cart.item_count); return cart; });
  }
  window.CDS_refreshCart = refreshCart;

  function esc(s){
    return String(s == null ? '' : s).replace(/[&<>"']/g, function(c){
      return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];
    });
  }

  function updateCount(n){
    document.querySelectorAll('[data-cart-count]').forEach(function(el){
      el.textContent = n; el.style.display = n>0 ? '' : 'none';
    });
  }

  function renderDrawer(cart){
    var wrap = document.querySelector('[data-cart-items]');
    var foot = document.querySelector('[data-cart-foot]');
    if(!wrap) return;
    if(cart.item_count === 0){
      wrap.innerHTML = '<div class="cd-empty"><p>' + esc(S('cartEmpty','Il tuo carrello è vuoto.')) + '</p><a href="' + (R() || '/') + '" class="btn btn-primary" data-cart-close>' + esc(S('cartContinue','Inizia lo shopping')) + '</a></div>';
      if(foot) foot.style.display='none';
      return;
    }
    if(foot) foot.style.display='';
    var html = cart.items.map(function(it){
      var img = it.image ? it.image + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=160' : '';
      /* link al prodotto nella lingua della pagina: aggiunge il prefisso solo se /cart.js non lo ha già messo */
      var url = it.url || '', root = R();
      if(root && url.indexOf(root + '/') !== 0) url = root + url;
      return '<div class="cd-item" data-key="'+esc(it.key)+'">'+
        (img?'<img class="cd-img" src="'+esc(img)+'" alt="">':'<div class="cd-img"></div>')+
        '<div><div class="cd-title"><a href="'+esc(url)+'">'+esc(it.product_title)+'</a></div>'+
        (it.variant_title && it.variant_title!=='Default Title' ? '<div class="cd-variant">'+esc(it.variant_title)+'</div>':'')+
        '<div class="cd-qty"><button data-qty-down>−</button><span>'+it.quantity+'</span><button data-qty-up>+</button></div></div>'+
        '<div style="text-align:right"><div class="cd-price">'+fmtMoney(it.final_line_price)+'</div>'+
        '<button class="cd-remove" data-remove>'+esc(S('cartRemove','Rimuovi'))+'</button></div>'+
      '</div>';
    }).join('');
    wrap.innerHTML = html;
    var sub = document.querySelector('[data-cart-subtotal]');
    if(sub) sub.textContent = fmtMoney(cart.total_price);
  }

  function changeLine(key, qty){
    return fetch(R() + '/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify({id:key,quantity:qty})}).then(function(r){return r.json();})
      .then(function(cart){ renderDrawer(cart); updateCount(cart.item_count); return cart; });
  }

  document.addEventListener('click', function(e){
    var item = e.target.closest('.cd-item'); if(!item) return;
    var key = item.getAttribute('data-key');
    var qtySpan = item.querySelector('.cd-qty span');
    var q = qtySpan ? parseInt(qtySpan.textContent,10) : 1;
    if(e.target.closest('[data-qty-up]')) changeLine(key, q+1);
    else if(e.target.closest('[data-qty-down]')) changeLine(key, Math.max(0,q-1));
    else if(e.target.closest('[data-remove]')) changeLine(key, 0);
  });

  /* ---------- AJAX add-to-cart (quick add + PDP) ---------- */
  document.addEventListener('submit', function(e){
    var form = e.target.closest('form[action$="/cart/add"], form[action*="/cart/add"]');
    if(!form || !form.hasAttribute('data-ajax-cart')) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    if(btn){ btn.disabled = true; btn.dataset.label = btn.textContent; btn.textContent = 'Aggiunto ✓'; }
    fetch(R() + '/cart/add.js',{method:'POST',headers:{'Accept':'application/json'},body:new FormData(form)})
      .then(function(r){return r.json();})
      .then(function(){ if(window.CDStrack){ try{ window.CDStrack.afterAdd(form); }catch(_){} } return refreshCart(); })
      .then(function(){ if(window.__cartType!=='page') openCart(); if(btn){ setTimeout(function(){btn.disabled=false; btn.textContent=btn.dataset.label||S('addToCart','Aggiungi al carrello');},900);} })
      .catch(function(){ if(btn){btn.disabled=false; btn.textContent=btn.dataset.label||S('addToCart','Aggiungi al carrello');} });
  });

  /* ---------- Carosello prodotti: frecce ---------- */
  function initSlider(s){
    var scope = s.closest('.section') || s.parentNode;
    var t=s.querySelector('.carousel-track'), a=scope.querySelectorAll('.nav-arrows .arrow');
    if(!t||a.length<2||t.dataset.sliderInit) return;
    t.dataset.sliderInit='1';
    function step(){ var c=t.querySelector('.carousel-card,.product-card'); return c?c.getBoundingClientRect().width+24:300; }
    a[0].addEventListener('click',function(){t.scrollBy({left:-step(),behavior:'smooth'});});
    a[1].addEventListener('click',function(){t.scrollBy({left:step(),behavior:'smooth'});});
  }
  function initSlidersIn(root){
    if(root.matches && root.matches('.carousel-slider')) initSlider(root);
    root.querySelectorAll('.carousel-slider').forEach(initSlider);
  }
  initSlidersIn(document);

  /* ---------- Product gallery: carosello scroll-snap (swipe mobile) + thumbs ---------- */
  document.querySelectorAll('[data-product-gallery]').forEach(function(g){
    var track = g.querySelector('[data-gallery-track]');
    var thumbs = g.querySelectorAll('[data-gallery-thumb]');
    if(!track) return;
    var strip = g.querySelector('.gallery-thumbs');
    /* la striscia miniature scorre: porta in vista quella attiva se è fuori dai bordi */
    function keepThumbVisible(t, smooth){
      if(!strip || strip.scrollWidth <= strip.clientWidth) return;
      var sr = strip.getBoundingClientRect(), tr = t.getBoundingClientRect(), d = 0;
      if(tr.left < sr.left) d = tr.left - sr.left;
      else if(tr.right > sr.right) d = tr.right - sr.right;
      if(d) strip.scrollBy({ left: d, behavior: smooth === false ? 'auto' : 'smooth' });
    }
    function setActive(i, smooth){
      thumbs.forEach(function(t){
        var on = t.getAttribute('data-index') === String(i);
        t.classList.toggle('active', on);
        if(on) keepThumbVisible(t, smooth);
      });
    }
    function goTo(i, smooth){
      track.scrollTo({ left: i * track.clientWidth, behavior: smooth === false ? 'auto' : 'smooth' });
      setActive(i, smooth);
    }
    thumbs.forEach(function(th){
      th.addEventListener('click', function(){
        goTo(parseInt(th.getAttribute('data-index'), 10) || 0);
      });
    });
    /* trascinamento col mouse sulla striscia: di suo il drag non scrolla, trascina l'immagine */
    if(strip){
      var syncScrollable = function(){
        strip.classList.toggle('is-scrollable', strip.scrollWidth > strip.clientWidth + 1);
      };
      var dragging = false, startX = 0, startScroll = 0, moved = 0;
      /* NIENTE setPointerCapture qui: con la cattura attiva Chrome consegna il click
         all'elemento che ha catturato (la striscia) e mai alla miniatura, che così
         diventa non cliccabile. Si seguono move/up sul document. */
      var onMove = function(e){
        if(!dragging) return;
        var dx = e.clientX - startX;
        if(Math.abs(dx) > moved) moved = Math.abs(dx);
        /* sotto soglia è un clic, non un trascinamento: non toccare nulla. preventDefault()
           qui sopprimerebbe gli eventi mouse di compatibilità e il click finirebbe sulla
           striscia invece che sulla miniatura, rendendola non cliccabile. */
        if(moved <= 4) return;
        strip.classList.add('dragging');
        strip.scrollLeft = startScroll - dx;
        e.preventDefault();
      };
      var endDrag = function(){
        if(!dragging) return;
        dragging = false;
        strip.classList.remove('dragging');
        document.removeEventListener('pointermove', onMove);
        document.removeEventListener('pointerup', endDrag);
        document.removeEventListener('pointercancel', endDrag);
      };
      strip.addEventListener('pointerdown', function(e){
        /* su touch lo scorrimento nativo funziona già, non toccarlo */
        if(e.button !== 0 || (e.pointerType && e.pointerType !== 'mouse')) return;
        if(strip.scrollWidth <= strip.clientWidth) return;
        dragging = true; moved = 0;
        startX = e.clientX; startScroll = strip.scrollLeft;
        document.addEventListener('pointermove', onMove);
        document.addEventListener('pointerup', endDrag);
        document.addEventListener('pointercancel', endDrag);
      });
      strip.addEventListener('dragstart', function(e){ e.preventDefault(); });
      /* dopo un trascinamento il rilascio non deve valere come clic sulla miniatura */
      strip.addEventListener('click', function(e){
        if(moved > 4){ e.preventDefault(); e.stopPropagation(); moved = 0; }
      }, true);
      syncScrollable();
      window.addEventListener('resize', syncScrollable);
    }
    /* il selettore variante chiede alla galleria di mostrare l'immagine collegata */
    g.addEventListener('gallery:goto', function(e){
      var d = e.detail || {};
      var i = parseInt(d.index, 10);
      if(isNaN(i)) return;
      goTo(i, d.smooth);
    });
    var raf;
    track.addEventListener('scroll', function(){
      if(raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function(){
        setActive(Math.round(track.scrollLeft / track.clientWidth));
      });
    });
  });

  /* ---------- Variant selector (PDP) ---------- */
  function normOpt(v){ return (v==null?'':String(v)).trim(); }
  document.querySelectorAll('[data-product-form]').forEach(function(form){
    var data = form.querySelector('[data-variants-json]');
    if(!data) return;
    var variants = [];
    try{ variants = JSON.parse(data.textContent||'[]'); }catch(e){ return; }
    /* prezzo e varianti sono blocchi del .buybox accanto al form, non dentro */
    var box = (form.closest && form.closest('.buybox')) || form;
    var nodeList = box.querySelectorAll('[data-option-index]');
    var idInput = form.querySelector('[name="id"]');
    var priceNow = box.querySelector('[data-price-now]');
    var priceWas = box.querySelector('[data-price-was]');
    var addBtn = form.querySelector('[data-add-btn]');
    var addLabel = addBtn ? (addBtn.dataset.label || addBtn.textContent.trim() || S('addToCart','Aggiungi al carrello')) : '';
    if(addBtn) addBtn.dataset.label = addLabel;
    /* prodotto senza opzioni: l'id del form è già quello giusto, non toccarlo */
    if(!nodeList.length) return;

    /* galleria della stessa PDP (mai quella di un'altra scheda prodotto in pagina) */
    var pdpScope = form.closest ? form.closest('.pdp-grid') : null;
    var gallery = pdpScope ? pdpScope.querySelector('[data-product-gallery]') : null;
    var firstPaint = true;
    /* all'apertura si vede l'immagine principale del prodotto, non quella della variante
       preselezionata d'ufficio: si salta subito alla variante solo se è l'URL a chiederla
       (link condiviso ?variant=…). Letto ora, prima che update() riscriva l'URL. */
    var urlAsksVariant = /[?&]variant=\d+/.test(window.location.search);
    /* porta in primo piano l'immagine associata alla variante, se il prodotto ne ha una */
    function showVariantMedia(mediaId){
      if(!gallery || !mediaId) return;
      if(firstPaint && !urlAsksVariant) return;
      var slide = gallery.querySelector('[data-gallery-slide][data-media-id="' + mediaId + '"]');
      if(!slide) return;
      var i = parseInt(slide.getAttribute('data-index'), 10);
      if(isNaN(i)) return;
      gallery.dispatchEvent(new CustomEvent('gallery:goto', { detail: { index: i, smooth: !firstPaint } }));
    }

    /* indicizza i select per posizione opzione e memorizza le etichette originali */
    var sels = [], labels = [], nOpts = 0;
    Array.prototype.forEach.call(nodeList, function(s){
      var k = parseInt(s.getAttribute('data-option-index'), 10);
      if(isNaN(k)) return;
      sels[k] = s;
      var map = {};
      Array.prototype.forEach.call(s.options, function(o){ map[normOpt(o.value)] = o.textContent; });
      labels[k] = map;
      if(k + 1 > nOpts) nOpts = k + 1;
    });

    function chosenNow(){
      var c = [];
      for(var k=0; k<nOpts; k++) c[k] = sels[k] ? normOpt(sels[k].value) : '';
      return c;
    }
    /* valori dell'opzione k che esistono davvero, date le scelte precedenti (0..k-1) */
    function validFor(k, chosen){
      var out = [];
      for(var i=0; i<variants.length; i++){
        var v = variants[i];
        if(!v.options || v.options.length !== nOpts) continue;
        var ok = true;
        for(var j=0; j<k; j++){ if(normOpt(v.options[j]) !== chosen[j]){ ok = false; break; } }
        if(!ok) continue;
        var val = normOpt(v.options[k]);
        if(out.indexOf(val) === -1) out.push(val);
      }
      return out;
    }
    function paintSwatches(k, valid, current){
      Array.prototype.forEach.call(box.querySelectorAll('[data-swatch][data-option="'+k+'"]'), function(sw){
        var val = normOpt(sw.getAttribute('data-value'));
        var show = valid.indexOf(val) !== -1;
        sw.style.display = show ? '' : 'none';
        sw.classList.toggle('active', show && val === current);
      });
    }
    /* un'opzione con un solo valore possibile non è una scelta: nascondi tutta la sezione
       (il select resta nel DOM col valore attivo, così il match della variante continua a funzionare) */
    function toggleSection(k, valid){
      var sel = sels[k];
      if(!sel) return;
      var wrap = sel.closest ? sel.closest('.variant-section') : null;
      if(wrap) wrap.style.display = valid.length <= 1 ? 'none' : '';
    }
    /* nasconde dalle opzioni successive i valori che non formano una variante esistente */
    function cascade(from){
      var chosen = chosenNow();
      for(var k = (from == null ? 1 : from + 1); k < nOpts; k++){
        var sel = sels[k];
        if(!sel) continue;
        var valid = validFor(k, chosen);
        var cur = normOpt(sel.value);
        sel.innerHTML = '';
        valid.forEach(function(val){
          var o = document.createElement('option');
          o.value = val;
          o.textContent = (labels[k] && labels[k][val]) || val;
          sel.appendChild(o);
        });
        sel.value = valid.indexOf(cur) !== -1 ? cur : (valid[0] || '');
        chosen[k] = normOpt(sel.value);
        paintSwatches(k, valid, chosen[k]);
      }
      /* visibilità + nome del valore scelto (utile quando le opzioni sono pastiglie colore) */
      for(var i = 0; i < nOpts; i++){
        var v = validFor(i, chosen);
        if(i === 0) paintSwatches(0, v, chosen[0]);
        toggleSection(i, v);
        var cur = box.querySelector('[data-option-current="'+i+'"]');
        if(cur) cur.textContent = chosen[i] || '';
      }
      update(chosen);
    }
    function update(chosen){
      chosen = chosen || chosenNow();
      var match = null;
      for(var i=0; i<variants.length; i++){
        var v = variants[i];
        if(!v.options || v.options.length !== nOpts) continue;
        var ok = true;
        for(var j=0; j<nOpts; j++){ if(normOpt(v.options[j]) !== chosen[j]){ ok = false; break; } }
        if(ok){ match = v; break; }
      }
      if(!match){
        /* fail-safe: mai aggiungere una variante stale/sbagliata in silenzio */
        if(idInput) idInput.value = '';
        if(addBtn){ addBtn.disabled = true; addBtn.textContent = 'Combinazione non disponibile'; }
        if(window.console) console.warn('[variante] nessun match per', chosen, 'tra', variants.map(function(v){return v.options;}));
        return;
      }
      if(idInput) idInput.value = match.id;
      /* URL condivisibile ?variant=… (come i temi Shopify standard) */
      try{
        var u = new URL(window.location.href);
        u.searchParams.set('variant', match.id);
        window.history.replaceState({}, '', u.toString());
      }catch(e){}
      if(priceNow) priceNow.textContent = fmtMoney(match.price);
      if(priceWas){ if(match.compare_at_price>match.price){ priceWas.textContent=fmtMoney(match.compare_at_price); priceWas.style.display=''; } else priceWas.style.display='none'; }
      if(addBtn){ addBtn.disabled = !match.available; addBtn.textContent = match.available ? addLabel : S('soldOut','Esaurito'); }
      showVariantMedia(match.media_id);
      firstPaint = false;
    }
    for(var k=0; k<nOpts; k++){
      (function(i){
        if(!sels[i]) return;
        sels[i].addEventListener('change', function(){ cascade(i); });
      })(k);
    }
    cascade(null);
  });

  /* ---------- Reel Instagram (Instafeed) ---------- */
  /* l'app riempie il feed quando vuole (lazy-load): appena compaiono i video il blocco si mostra e si
     accendono i link che puntano lì. Feed vuoto = blocco invisibile, nessun timeout: se l'app carica
     tardi, il blocco compare comunque. */
  document.querySelectorAll('[data-reels]').forEach(function(box){
    var feed = box.querySelector('[data-reels-feed]');
    if(!feed) return;
    var MEDIA = 'img, video, iframe, [class*="instafeed-new-layout-item"], [class*="instafeed-item"]';
    function found(){
      if(!feed.querySelector(MEDIA)) return false;
      box.classList.add('has-reels');
      document.querySelectorAll('[data-reels-link]').forEach(function(a){
        if(a.getAttribute('href') === '#' + box.id) a.hidden = false;
      });
      return true;
    }
    if(found()) return;
    var mo = new MutationObserver(function(){ if(found()) mo.disconnect(); });
    mo.observe(feed, { childList: true, subtree: true });
  });

  /* ---------- Product recommendations (Section Rendering API) ---------- */
  document.querySelectorAll('[data-product-recommendations]').forEach(function(el){
    var url = el.getAttribute('data-url');
    if(!url) return;
    fetch(url).then(function(r){return r.text();}).then(function(text){
      var html = document.createElement('div');
      html.innerHTML = text;
      var fresh = html.querySelector('[data-product-recommendations]');
      if(fresh && fresh.innerHTML.trim().length){ el.innerHTML = fresh.innerHTML; initSlidersIn(el); if(window.CDSwish) window.CDSwish.paint(el); }
    }).catch(function(){});
  });

  /* ---------- Mobile nav drawer ---------- */
  function openNav(){ body.classList.add('nav-open'); moveFocusTo('.mobile-nav'); }
  function closeNav(){ if(body.classList.contains('nav-open')){ body.classList.remove('nav-open'); restoreFocus(); } }
  document.addEventListener('click', function(e){
    if(e.target.closest('[data-nav-open]')){ e.preventDefault(); openNav(); return; }
    if(e.target.closest('[data-nav-close]')){ e.preventDefault(); closeNav(); return; }
    var fh = e.target.closest('.filter-head');
    if(fh){ var blk = fh.closest('.filter-block'); if(blk) blk.classList.toggle('collapsed'); }
  });
  document.addEventListener('keydown', function(e){ if(e.key==='Escape') closeNav(); });

  /* ---------- Blocco SEO collezione: espandi/comprimi ---------- */
  document.addEventListener('click', function(e){
    var t = e.target.closest('[data-seo-toggle]');
    if(!t) return;
    var body = t.parentNode.querySelector('[data-seo-body]');
    if(!body) return;
    var collapsed = body.classList.toggle('collapsed');
    t.textContent = collapsed ? (t.dataset.more || 'Leggi tutto +') : (t.dataset.less || 'Chiudi −');
  });

  /* ---------- PDP tabs dettaglio ---------- */
  document.addEventListener('click', function(e){
    var btn = e.target.closest('[data-pdp-tabs] .tab-btn');
    if(!btn) return;
    var root = btn.closest('[data-pdp-tabs]');
    var key = btn.getAttribute('data-tab');
    root.querySelectorAll('.tab-btn').forEach(function(b){ b.classList.toggle('active', b === btn); });
    root.querySelectorAll('.tab-content').forEach(function(p){ p.classList.toggle('active', p.getAttribute('data-tab-panel') === key); });
  });

  /* ---------- FAQ accordion ---------- */
  document.addEventListener('click', function(e){
    var q = e.target.closest('[data-faq-q]');
    if(!q) return;
    var item = q.closest('.faq-item');
    if(!item) return;
    var open = item.classList.toggle('open');
    q.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  /* ---------- Featured tabs (best seller) ---------- */
  document.addEventListener('click', function(e){
    var tab = e.target.closest('[data-ft-tab]');
    if(!tab) return;
    var root = tab.closest('[data-featured-tabs]');
    if(!root) return;
    var idx = tab.getAttribute('data-ft-tab');
    root.querySelectorAll('[data-ft-tab]').forEach(function(t){ t.classList.toggle('active', t === tab); });
    root.querySelectorAll('[data-ft-panel]').forEach(function(p){ p.classList.toggle('active', p.getAttribute('data-ft-panel') === idx); });
    var va = root.querySelector('.ft-viewall');
    var url = tab.getAttribute('data-ft-url');
    if(va && url){ va.setAttribute('href', url); }
  });

  /* ---------- Brand slider arrows ---------- */
  document.addEventListener('click', function(e){
    var arrow = e.target.closest('.brand-arrow');
    if(!arrow) return;
    var wrap = arrow.closest('.brand-track-wrap');
    if(!wrap) return;
    var row = wrap.querySelector('.brand-row');
    if(!row) return;
    var dir = arrow.classList.contains('prev') ? -1 : 1;
    row.style.animationPlayState = 'paused';
    var t = getComputedStyle(row).transform;
    var current = (t && t !== 'none') ? (parseFloat(t.split(',')[4]) || 0) : 0;
    row.style.transition = 'transform .5s ease';
    row.style.transform = 'translateX(' + (current - dir*278) + 'px)';
  });

  /* ---------- Flash countdown (solo con data reale; nascosto a offerta scaduta) ---------- */
  document.querySelectorAll('[data-countdown]').forEach(function(el){
    var endStr = el.getAttribute('data-countdown-end');
    var end = endStr ? new Date(endStr.replace(' ', 'T')).getTime() : NaN;
    if(!end || isNaN(end)){ el.style.display = 'none'; return; }
    var timer;
    function pad(n){ return String(n).padStart(2, '0'); }
    function set(k, v){ var n = el.querySelector('[data-cd="' + k + '"]'); if(n){ n.textContent = pad(v); } }
    function tick(){
      var diff = end - Date.now();
      if(diff <= 0){ el.style.display = 'none'; if(timer) clearInterval(timer); return; }
      set('d', Math.floor(diff/86400000));
      set('h', Math.floor(diff/3600000)%24);
      set('m', Math.floor(diff/60000)%60);
      set('s', Math.floor(diff/1000)%60);
    }
    tick();
    timer = setInterval(tick, 1000);
  });

  /* ---------- Indirizzi cliente: toggle form + select paese/provincia collegate ---------- */
  document.addEventListener('click', function(e){
    var t = e.target.closest('[data-address-toggle]');
    if(!t) return;
    var box = document.getElementById(t.getAttribute('data-address-toggle'));
    if(box){ box.style.display = (!box.style.display || box.style.display === 'none') ? 'block' : 'none'; }
  });
  document.querySelectorAll('[data-address-form]').forEach(function(form){
    var country = form.querySelector('[data-address-country]');
    var province = form.querySelector('[data-address-province]');
    var wrap = form.querySelector('[data-address-province-wrap]');
    if(!country || !province) return;
    var provDefault = province.getAttribute('data-default') || '';
    function sync(){
      var opt = country.options[country.selectedIndex];
      var provinces = [];
      try { provinces = JSON.parse(opt.getAttribute('data-provinces') || '[]'); } catch(_){}
      province.innerHTML = '';
      if(!provinces.length){ if(wrap){ wrap.style.display = 'none'; } return; }
      if(wrap){ wrap.style.display = ''; }
      provinces.forEach(function(p){
        var o = document.createElement('option');
        o.value = p[0]; o.textContent = p[1];
        province.appendChild(o);
      });
      if(provDefault){ province.value = provDefault; }
    }
    var cDefault = country.getAttribute('data-default');
    if(cDefault){ country.value = cDefault; }
    country.addEventListener('change', function(){ provDefault = ''; sync(); });
    sync();
  });

  /* ---------- Visti di recente (localStorage + Section Rendering API) ---------- */
  (function(){
    var el = document.querySelector('[data-recently-viewed]');
    if(!el) return;
    var KEY = 'cds_recently_viewed';
    var current = el.getAttribute('data-current-id');
    var list = [];
    try { list = JSON.parse(localStorage.getItem(KEY) || '[]'); } catch(_){ list = []; }
    list = list.filter(function(id){ return id && String(id) !== String(current); });
    if(current){
      list.unshift(current);
      list = list.slice(0, 12);
      try { localStorage.setItem(KEY, JSON.stringify(list)); } catch(_){}
    }
    var toShow = list.filter(function(id){ return String(id) !== String(current); });
    var limit = parseInt(el.getAttribute('data-limit'), 10) || 4;
    toShow = toShow.slice(0, limit);
    if(!toShow.length) return;
    var q = toShow.map(function(id){ return 'id:' + id; }).join(' OR ');
    fetch(el.getAttribute('data-url') + '&q=' + encodeURIComponent(q))
      .then(function(r){ return r.text(); })
      .then(function(html){
        var doc = document.createElement('div');
        doc.innerHTML = html;
        var fresh = doc.querySelector('[data-recently-viewed]');
        if(fresh && fresh.querySelector('.product-card')){
          el.innerHTML = fresh.innerHTML;
          el.removeAttribute('hidden');
          initSlidersIn(el);
          if(window.CDSwish) window.CDSwish.paint(el);
        }
      }).catch(function(){});
  })();

  /* ---------- Trustpilot widget prodotto: init lazy (uno alla volta, quando entra nel viewport) ---------- */
  (function(){
    var nodes = document.querySelectorAll('[data-tp-product]');
    if(!nodes.length) return;
    var queue = [];
    var tpReady = false;
    function flush(){ tpReady = true; queue.splice(0).forEach(function(el){ load(el); }); }
    function whenReady(el){ if(tpReady){ load(el); } else { queue.push(el); } }
    function load(el){
      if(!window.Trustpilot || !window.Trustpilot.loadFromElement) return;
      Trustpilot.loadFromElement(el, true);
    }
    (function poll(){
      if(window.Trustpilot && window.Trustpilot.loadFromElement){ flush(); return; }
      setTimeout(poll, 200);
    })();
    function init(el){
      if(el.dataset.tpInit) return;
      el.dataset.tpInit = '1';
      whenReady(el);
    }
    if('IntersectionObserver' in window){
      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(e){ if(e.isIntersecting){ init(e.target); io.unobserve(e.target); } });
      }, { rootMargin: '250px' });
      nodes.forEach(function(n){ io.observe(n); });
    } else {
      nodes.forEach(init);
    }
  })();

  /* ---------- Tracking caroselli (click-through 3gg + funnel beacon, view-through predisposta) ---------- */
  (function(){
    var MEM_KEY = 'cds_carousel_src';
    var SEEN_KEY = 'cds_carousel_seen';
    var TTL = 3 * 24 * 60 * 60 * 1000; // 3 giorni

    function loadMem(){ try { return JSON.parse(localStorage.getItem(MEM_KEY) || '{}'); } catch(_){ return {}; } }
    function saveMem(m){ try { localStorage.setItem(MEM_KEY, JSON.stringify(m)); } catch(_){} }
    function remember(handle, source){
      if(!handle || !source) return;
      var m = loadMem(), now = Date.now();
      Object.keys(m).forEach(function(k){ if(!m[k] || (now - m[k].ts) > TTL) delete m[k]; });
      m[handle] = { source: source, ts: now };
      saveMem(m);
    }
    function recall(handle){
      if(!handle) return null;
      var m = loadMem(), e = m[handle];
      if(!e) return null;
      if((Date.now() - e.ts) > TTL){ delete m[handle]; saveMem(m); return null; }
      return e.source;
    }
    function handleFromHref(href){ var mm = /\/products\/([^/?#]+)/.exec(href || ''); return mm ? mm[1] : null; }

    function sid(){
      if(!window.__carouselTrackingEndpoint) return ''; // nessun cookie finché il funnel beacon è spento
      var m = document.cookie.match(/(?:^|;\s*)cds_sid=([^;]+)/);
      if(m) return decodeURIComponent(m[1]);
      var v = 'x' + Math.random().toString(36).slice(2) + Date.now().toString(36);
      var d = new Date(Date.now() + 30*24*60*60*1000);
      document.cookie = 'cds_sid=' + encodeURIComponent(v) + ';path=/;expires=' + d.toUTCString() + ';SameSite=Lax;Secure';
      return v;
    }
    function beacon(payload){
      var url = window.__carouselTrackingEndpoint; if(!url) return;
      try {
        var body = JSON.stringify(payload);
        if(navigator.sendBeacon){ navigator.sendBeacon(url, new Blob([body], { type: 'text/plain' })); }
        else { fetch(url, { method:'POST', keepalive:true, headers:{'Content-Type':'text/plain'}, body: body }).catch(function(){}); }
      } catch(_){}
    }

    /* click su prodotto dentro un carosello → memorizza sorgente + beacon */
    document.addEventListener('click', function(e){
      var a = e.target.closest('a[href*="/products/"]'); if(!a) return;
      var car = a.closest('[data-carousel-source]'); if(!car) return;
      var source = car.getAttribute('data-carousel-source');
      var handle = handleFromHref(a.getAttribute('href'));
      remember(handle, source);
      var cards = car.querySelectorAll('.product-card');
      var card = a.closest('.product-card');
      var pos = card ? Array.prototype.indexOf.call(cards, card) : -1;
      beacon({ event:'carousel_click', source:source, product_handle:handle, position:pos, page:location.pathname, session_id:sid(), ts:Date.now() });
    });

    /* impression → view-through (una per carosello per sessione) */
    if('IntersectionObserver' in window){
      var seen; try { seen = JSON.parse(sessionStorage.getItem(SEEN_KEY) || '[]'); } catch(_){ seen = []; }
      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(en){
          if(!en.isIntersecting) return;
          var el = en.target; io.unobserve(el);
          var source = el.getAttribute('data-carousel-source');
          if(!source || seen.indexOf(source) !== -1) return;
          seen.push(source);
          try { sessionStorage.setItem(SEEN_KEY, JSON.stringify(seen)); } catch(_){}
          beacon({ event:'carousel_view', source:source, page:location.pathname, session_id:sid(), ts:Date.now() });
        });
      }, { rootMargin:'0px' });
      document.querySelectorAll('[data-carousel-source]').forEach(function(el){ io.observe(el); });
    }

    window.CDStrack = {
      afterAdd: function(form){
        var source = null;
        var car = form.closest && form.closest('[data-carousel-source]');
        if(car) source = car.getAttribute('data-carousel-source');
        if(!source){ source = recall(form.getAttribute && form.getAttribute('data-product-handle')); }
        if(!source) return;
        fetch(R() + '/cart.js',{headers:{'Accept':'application/json'}})
          .then(function(r){ return r.json(); })
          .then(function(cart){
            var cur = (cart.attributes && cart.attributes.carousel_sources) || '';
            var set = cur ? cur.split(',') : [];
            if(set.indexOf(source) === -1) set.push(source);
            var attrs = { carousel_sources: set.join(',') };
            var s = sid(); if(s) attrs.carousel_session = s; // solo quando il funnel è attivo
            fetch(R() + '/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},
              body:JSON.stringify({ attributes: attrs })}).catch(function(){});
            beacon({ event:'carousel_add_to_cart', source:source,
              product_handle:(form.getAttribute && form.getAttribute('data-product-handle')) || null,
              page:location.pathname, session_id:s, cart_token:cart.token, ts:Date.now() });
          }).catch(function(){});
      }
    };
  })();

  /* ---------- Wishlist: preferiti nel browser, nessuna app ----------
     I preferiti vivono in localStorage: per dispositivo, senza account. La pagina
     wishlist non ridisegna la card in JavaScript, se la fa rendere da Shopify
     (sections/wishlist-card.liquid) così resta identica a quelle del resto del sito. */
  (function(){
    var KEY = 'cds_wishlist';

    function read(){
      try { var a = JSON.parse(localStorage.getItem(KEY) || '[]'); return Array.isArray(a) ? a : []; }
      catch(_){ return []; }
    }
    function write(a){ try { localStorage.setItem(KEY, JSON.stringify(a)); } catch(_){} }

    function paint(root){
      var list = read();
      (root || document).querySelectorAll('[data-wish]').forEach(function(b){
        var on = list.indexOf(b.getAttribute('data-wish')) !== -1;
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        var txt = b.querySelector('[data-wish-text]');
        if(txt) txt.textContent = on ? (b.getAttribute('data-wish-on') || S('wishlistSaved','Salvato nella wishlist'))
                                    : (b.getAttribute('data-wish-off') || S('wishlistAdd','Aggiungi alla wishlist'));
        var ic = b.querySelector('[data-wish-icon]');
        if(ic) ic.textContent = on ? '\u2665' : '\u2661';
      });
      document.querySelectorAll('[data-wish-count]').forEach(function(el){
        el.textContent = list.length;
        el.hidden = list.length === 0;
      });
    }

    var grid = document.querySelector('[data-wishlist-grid]');
    var empty = document.querySelector('[data-wishlist-empty]');

    function renderGrid(){
      if(!grid) return;
      var list = read();
      if(empty) empty.hidden = list.length > 0;
      grid.innerHTML = '';
      list.forEach(function(handle){
        /* segnaposto: le richieste tornano in ordine sparso, la lista no */
        var slot = document.createElement('div');
        grid.appendChild(slot);
        fetch(R() + '/products/' + encodeURIComponent(handle) + '?section_id=wishlist-card')
          .then(function(r){ return r.ok ? r.text() : null; })
          .then(function(html){
            var card = null;
            if(html){
              var box = document.createElement('div');
              box.innerHTML = html;
              card = box.querySelector('.product-card');
            }
            if(!card){
              /* prodotto non più in catalogo: esce anche dalla lista */
              var l = read(), i = l.indexOf(handle);
              if(i !== -1){ l.splice(i, 1); write(l); paint(); if(empty) empty.hidden = l.length > 0; }
              slot.remove();
              return;
            }
            slot.replaceWith(card);
            paint(card);
          })
          .catch(function(){ slot.remove(); });
      });
    }

    document.addEventListener('click', function(e){
      var b = e.target.closest && e.target.closest('[data-wish]');
      if(!b) return;
      e.preventDefault();
      var handle = b.getAttribute('data-wish');
      var list = read(), i = list.indexOf(handle);
      if(i === -1) list.push(handle); else list.splice(i, 1);
      write(list);
      paint();
      /* tolto dalla pagina wishlist: la card sparisce subito */
      if(grid && i !== -1 && grid.contains(b)){
        var card = b.closest('.product-card');
        if(card) card.remove();
        if(empty) empty.hidden = list.length > 0;
      }
    });

    window.CDSwish = { paint: paint };
    paint();
    renderGrid();
  })();

  /* init */
  refreshCart && document.querySelector('[data-cart-items]') && refreshCart();
})();